import N8nColorPicker from './ColorPicker.vue';

export default N8nColorPicker;
